import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const TemporaryPasswordDialog = ({
  open,
  onClose,
  title,
  description,
  password,
  userId,
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) {
      setCopied(false);
    }
  }, [open]);

  const handleCopy = async () => {
    if (!password) return;

    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    } catch (error) {
      setCopied(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{
          backgroundColor: "#3857a6",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontFamily: "Montserrat-Bold",
        }}
      >
        {title}
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={2}>
          <Typography sx={{ fontFamily: "Montserrat-Regular", color: "#475569" }}>
            {description}
          </Typography>

          <Box
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(56,87,166,0.2)",
              backgroundColor: "#f8fafc",
              px: 2,
              py: 1.5,
            }}
          >
            <Typography sx={{ fontFamily: "Montserrat-Medium", fontSize: "0.82rem", color: "#64748b", mb: 0.5 }}>
              Usuario
            </Typography>
            <Typography sx={{ fontFamily: "Montserrat-Bold", fontSize: "1rem", color: "#1e293b", mb: 1 }}>
              {userId || "-"}
            </Typography>

            <Typography sx={{ fontFamily: "Montserrat-Medium", fontSize: "0.82rem", color: "#64748b", mb: 0.5 }}>
              Contraseña inicial
            </Typography>
            <Typography
              sx={{
                fontFamily: "monospace",
                fontSize: "1.05rem",
                color: "#031A7F",
                wordBreak: "break-all",
              }}
            >
              {password || "-"}
            </Typography>
          </Box>

          <Alert severity="warning" variant="outlined">
            Esta contraseña corresponde al DNI del usuario y solo se muestra ahora. El usuario deberá cambiarla al iniciar sesión.
          </Alert>

          {copied && (
            <Alert severity="success" variant="outlined">
              Contraseña copiada al portapapeles.
            </Alert>
          )}
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={handleCopy}
          variant="outlined"
          startIcon={<ContentCopyIcon />}
          sx={{ textTransform: "none", fontFamily: "Montserrat-Medium" }}
        >
          Copiar contraseña inicial
        </Button>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            textTransform: "none",
            fontFamily: "Montserrat-Medium",
            backgroundColor: "#3857a6",
            "&:hover": { backgroundColor: "#2f4c98" },
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemporaryPasswordDialog;
